import React from "react";
import { Header, Quota, Contract } from "../../components/common";
import './AddStudent.css';
import { useState } from 'react';
import { EDUCATION_TYPE_LIST, EDUCATION_TYPES } from '../../utils/consts/educationType';


function AddStudent() {

  const [educationType, setEducationType] = useState(EDUCATION_TYPES.CONTRACT);

  return (
    <>
      <Header />
      <div className="container_AddStudent">
        <p className="title_AddStudent">Добавить студента</p>
        <div className="button_position_addStud">
          {/* Выбранный тип подсвечен состоянием disabled — так было и с двумя кнопками. */}
          {EDUCATION_TYPE_LIST.map((type) => (
            <button key={type} onClick={() => setEducationType(type)} type="button"
                    disabled={educationType === type}
                    className="button_style_addStudent">{type}
            </button>
          ))}
        </div>
        {
          educationType === EDUCATION_TYPES.QUOTA
            ? <Quota />
            : <Contract educationType={educationType} />
        }
      </div>
    </>
  );
}

export default AddStudent;
